// App.js

import React from "react";
import "./App.css";

// 1. Importer votre composant Logo
import Logo from "./Logo";

// 2. Importer votre composant principal ApplicationPLL
import ApplicationPLL from "./FluxAdminInterface"; // <-- MODIFIÉ ICI

function App() {
  return (
    <div className="app-container">
      <header className="app-header">
        <Logo />
      </header>

      <main className="app-main-content">
        <ApplicationPLL /> {/* <-- MODIFIÉ ICI */}
      </main>
    </div>
  );
}

export default App;
